import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-fillblank@2x.png'
export default {
  orderById: 150,
  elementType: 'FillBlankBox',
  elementDesc: '完形填空题',
  type: 'fillblankbox',
  // 是否可配置
  config: true,
  title: '完形填空题',
  placeholder: '完形填空题',
  isRequired: '1',
  quNote: '', // 题目内容
  imgUrl: '', // 题目图片
  imgName: '', // 图片名称
  hv: '1', // 1图上文下 2图下文上
  // 选项vo
  descList: [],
  optionList: [{
    quId: '',
    optionName: '',
    optionLength: ''
  }],
  value: [],
  ruleError: '该字段不能为空',
  toolbar: {
    config: false
  },
  saveUrl: '/design/qu-multi-fillblank/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      optionList: this.optionList
    }, this)
  },
  saveCb (data) {
    this.optionList = data.optionList
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/FillBlankBox/config.js